import { mutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { createApiKey, revokeApiKey } from '../../api/apiKeysService';

import { apiKeysKeys, apiKeysMutationKeys } from './keys';

// Create handles its result inline (the plaintext secret must be shown once) and surfaces
// errors in the form, so it opts out of the global error toast.
export const createApiKeyOptions = (queryClient) =>
	mutationOptions({
		mutationKey: apiKeysMutationKeys.create,
		mutationFn: (payload) => createApiKey(payload),
		meta: { suppressGlobalError: true },
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: apiKeysKeys.all });
		},
	});

export function useCreateApiKey() {
	const queryClient = useQueryClient();
	return useMutation(createApiKeyOptions(queryClient));
}

export const revokeApiKeyOptions = (queryClient) =>
	mutationOptions({
		mutationKey: apiKeysMutationKeys.revoke,
		mutationFn: (keyId) => revokeApiKey(keyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: apiKeysKeys.all });
		},
	});

export function useRevokeApiKey() {
	const queryClient = useQueryClient();
	return useMutation(revokeApiKeyOptions(queryClient));
}
